
import React from 'react';
import classes from './campOffer.module.css';

const CampOffer = (props) => {
    let valid_until = `Valid until ${new Date(props.early_bird_end_date).toLocaleDateString('en-US', {
                    month: 'long', day: 'numeric'})}`;
    let currency = "JD"; 

    const language = parseInt(localStorage.getItem('language'), 10);

    if (!isNaN(language) && language !== 1) {
        currency = "دينار";
        valid_until = `صالحة حتى ${new Date(props.early_bird_end_date).toLocaleDateString('ar-JD', {
                    month: 'long', day: 'numeric'})}`;
    }
    return (
        <li key={props.key} className={classes.CampOffer}>
            <div className={classes.Duration}>{props.name ? props.name : props.duration}</div>
            {props.early_bird_end_date ? <div className={classes.AvailableDate}>
                {valid_until}
            </div> : <div className={classes.UnAvailableDate} />}
            <div className={classes.Discount}>{props.discount_label}</div>
            <div className={classes.PriceAfterDiscount}>{props.early_bird_price ? props.early_bird_price : props.price} {currency}</div>
            <div className={classes.PriceBeforeDiscount}> {props.discount_percentage !== '0' ? `${props.base_price} ${currency}` : ''}</div>
            <button onClick={props.clicked}>{parseInt(localStorage.getItem('language')) === 1 ? "GET NOW" : "احجز الآن"}</button>
        </li>
    )
}

export default CampOffer;